import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Switch, InputNumber, message } from 'antd';
import {closeUpdatePriceModal} from '../../redux/actions/collection/toggleModals';
import {updatePrice} from '../../redux/actions/collection/updatePrice';

class UpdatePriceModal extends React.Component {
    constructor(props){
        super(props);
        this.form=React.createRef();
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };
    onFinish = async (values) => {
        await this.props.onUpdate(values, this.props.match?.id,this.props.token);
        if(this.props.error){
            message.error(this.props.error);
        }
        if(this.props.message){
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Price Info"
                key={this.props.match?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-price-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-price-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        homeUpper:this.props.match?.homeUpper,
                        odds:this.props.match?.odds,
                        price:this.props.match?.price,
                        goalTotal:this.props.match?.goalTotal,
                        goalTotalPrice:this.props.match?.goalTotalPrice,
                        bodyGap:this.props.match?.bodyGap,
                        goalsGap:this.props.match?.goalsGap
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="homeUpper"
                        valuePropName="checked"
                        label="Home Upper"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Switch checkedChildren="home" unCheckedChildren="away" />
                    </Form.Item>
                    <Form.Item
                        name="odds"
                        label="Odds"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="price"
                        label="Price"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="goalTotal"
                        label="Goal Total"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="goalTotalPrice"
                        label="Goal Total Price"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="bodyGap"
                        label="Body Gap"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="goalsGap"
                        label="Goals Gap"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.collection.updatePriceVisible,
    loading: state.collection.loading,
    match: state.collection.match,
    token: state.auth.token,
    error:state.collection.error,
    message:state.collection.message
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (priceinfo,matchId, token) => dispatch(updatePrice(priceinfo,matchId, token)),
    onClose: () => dispatch(closeUpdatePriceModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePriceModal);